import React from 'react';
import { TouchableOpacity, TouchableOpacityProps } from 'react-native';
import { Constants } from 'src/constants/constants';
import { pixelScaler } from 'src/themes/Metrics';
import styled from 'styled-components/native';

const Styled = {
  Wrapper: styled(TouchableOpacity)`
    width: ${pixelScaler(30)}px;
    height: ${pixelScaler(30)}px;
    align-items: center;
    justify-content: center;
  `,
};

interface Props extends TouchableOpacityProps {
  disabled?: boolean;
  icon: React.ReactElement;
}

export const IconButton = ({ disabled = false, icon, style = {}, onPress }: Props) => {
  return (
    <Styled.Wrapper disabled={disabled} style={style} activeOpacity={Constants.ACTIVE_OPACITY} onPress={onPress}>
      {icon}
    </Styled.Wrapper>
  );
};
